import $ from 'cash-dom';
import { forEach, startsWith, replace } from 'lodash';

import * as actions from 'state/actions';
import Rudderstack from 'utils/Rudderstack';
import { parseQueryString } from 'utils/Url';

const EXPERIMENT_URL_PREFIX = 'experiment_';

const ExperimentsController = class {
  static activateExperiment = store => (experimentIdentifier, options) => {
    $('body').addClass(`experiment--${experimentIdentifier}`);
    store.dispatch(actions.activateExperiment(experimentIdentifier, options));
  };

  static experimentViewed = () => (tagId, tagName, experienceName, experience, variations) => {
    const variation = variations?.[0];

    const analyticsData = {
      campaignId: tagId,
      campaignName: tagName,
      experienceId: experience?.id,
      experienceName,
      variationId: variation?.id,
      variationName: decodeURIComponent(variation?.name),
    };

    Rudderstack.experimentViewed({
      analyticsData,
      experimentType: 'Web Personalization',
    });
  };

  static mountExperimentsEntrypoint = store => {
    window.ALLBIRDS = window.ALLBIRDS || {};
    window.ALLBIRDS.activateExperiment = ExperimentsController.activateExperiment(store);
    window.ALLBIRDS.experimentViewed = ExperimentsController.experimentViewed();
  };

  static activateGoogleOptimize = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'optimize.activate' });
  };

  static get urlParams() {
    return parseQueryString();
  }

  static activateExperimentsFromUrl = () => {
    // Look for URL params with format "experiment_<identifier>" to activate relevant experiments
    forEach(ExperimentsController.urlParams, (value, key) => {
      if (startsWith(key, EXPERIMENT_URL_PREFIX)) {
        const experimentName = replace(key, EXPERIMENT_URL_PREFIX, '');

        window.ALLBIRDS.activateExperiment(experimentName);
      }
    });
  };

  static init = store => {
    ExperimentsController.mountExperimentsEntrypoint(store);
    ExperimentsController.activateGoogleOptimize();
    ExperimentsController.activateExperimentsFromUrl();
  };
};

export default ExperimentsController;
